// Routes that have internalCachedRoute in the URL will be cached by Akamai
export const internalCachedRoute = '/icr';
export const icr_googleMapSignUrl = `${internalCachedRoute}/googleMapSignUri`;
export const icr_shortUrl = `${internalCachedRoute}/shortURL`;
export const icr_health = `${internalCachedRoute}/health`;
